<button (click)="onClick()"
  class="btn"
  [ngClass]="[
    'btn-' + type(),
    size() === 'small' ? 'btn-sm' : '',
    size() === 'large' ? 'btn-lg' : '',
    iconLeft() && !iconRight() && !label() ? 'btn-icon' : '',
    iconRight() && !iconLeft() && !label() ? 'btn-icon' : ''
  ]"
  [disabled]="disabled() || loading()"
>
  <!-- Left icon -->
   @if(iconLeft() && !loading()){
    <i [class]="iconLeft()"></i>
   }

  <!-- Loader on the left -->
  @if(loading() && loadingIconPosition() === 'left'){
    <span class="spinner-border spinner-border-sm"></span>
  }

  <!-- Label (only if label or loadingLabel exists) -->
   @if(label() || (loading() && loadingLabel())){
    <span>
      {{ loading() && loadingLabel() ? loadingLabel() : label() }}
    </span>
   }

  <!-- Loader on the right -->
  @if(loading() && loadingIconPosition() === 'right'){
    <span class="spinner-border spinner-border-sm"></span>
  }

  <!-- Right icon -->
   @if(iconRight() && !loading()){
    <i [class]="iconRight()"></i>
   }
</button>
